import React from 'react';
import VoxelAlert from '../../../components/voxel/Alert/VoxelAlert';

export interface NotEnoughTagGroupsProps {}

export const NotEnoughTagGroups: React.FC<NotEnoughTagGroupsProps> = ({}) => {
  return (
    <div data-screenshot-id="chart-loaded">
      {/* We add the chart-loaded marker so that screenshoting won't get stuck if it happens to end up here */}
      <VoxelAlert severity="warning">Select at least one tag group to display chart</VoxelAlert>
    </div>
  );
};

export default NotEnoughTagGroups;
